module.exports = __webpack_public_path__ + "static/media/01-ive-come-to-free-the-words.cdb99f4d.mp3";